import React from 'react';
import { FileText, AlertCircle } from 'lucide-react';

const Reports = () => {
  return (
    <div className="space-y-6">
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Reports & Analytics
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Generate comprehensive security reports and executive summaries
          </p>
        </div>
      </div>

      <div className="card text-center py-12">
        <FileText className="h-16 w-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Report Generator</h3>
        <p className="text-gray-500 mb-4">
          Automated report generation and analytics dashboard coming soon.
        </p>
        <div className="flex items-center justify-center text-sm text-orange-600">
          <AlertCircle className="h-4 w-4 mr-1" />
          Under Development
        </div>
      </div>
    </div>
  );
};

export default Reports;